<template>
  <Menu
    as="div"
    class="md:relative"
  >
    <MenuButton
      class="w-full bg-gray-100 flex items-center justify-between rounded-full border border-gray-400 text-blue-600 text-xs md:text-sm font-medium px-3.5 py-1"
    >
      Filters
      <ChevronDownIcon
        class="text-gray-500 h-4 w-4 -mr-1"
        aria-hidden="true"
      />
    </MenuButton>

    <MenuItems
      class="overflow-hidden origin-top-left absolute left-4 right-4 rounded-md shadow-lg bg-gray-100 z-20 md:w-80 p-3 border border-gray-400 mt-1"
    >
      <MenuItem
        as="button"
        @click="showSaveFilterPrompt = true"
        class="btn btn-secondary-outline w-full"
      >
        Save Active Filters
      </MenuItem>

      <TransitionGroup name="fade">
        <MenuItem
          v-for="filter in props.savedFilters"
          :key="filter.name"
          as="div"
          class="flex justify-between items-center py-2"
        >
          <button
            type="button"
            class="text-gray-700 group flex items-center px-4 py-2 text-sm w-full rounded-md rounded-r-none"
            @click="emit('load', filter)"
          >
            {{ filter.name }}
          </button>
          <button
            type="button"
            class="text-gray-700 hover:bg-red-600 hover:text-red-200 group flex items-center px-3 py-2 text-sm rounded-md border border-gray-400"
            @click.prevent="emit('delete', filter)"
          >
            <TrashIcon class="w-4 h-4" />
          </button>
        </MenuItem>
      </TransitionGroup>
    </MenuItems>
  </Menu>

  <SavedFilterPromptModal
    :show="showSaveFilterPrompt"
    @close="showSaveFilterPrompt = false"
    @save="({ filterName }) => emit('save', { filterName })"
  />
</template>

<script setup>
import { ref } from 'vue'
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import { TrashIcon } from '@heroicons-2/vue/24/outline'
import { ChevronDownIcon } from '@heroicons/vue/solid'
import SavedFilterPromptModal from '@/Components/SavedFilters/Prompt.vue'

const emit = defineEmits(['save', 'load', 'delete'])

const props = defineProps({
  savedFilters: {
    type: Object,
    required: true
  }
})

const showSaveFilterPrompt = ref(false)
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
